import clsx from 'clsx';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "hint": "pbui-wMK1O",
  "hint--no-error": "pbui-1ISdA",
  "hint--has-error": "pbui-CSYRt",
  "label": "pbui-uSTEQ",
  "container": "pbui-o6M00",
  "input__container": "pbui-lHuol",
  "input__container--disabled": "pbui-gsd4w",
  "input__container--has-error": "pbui-gYDjp",
  "dropdown": "pbui-9igeY",
  "input": "pbui-GYwBg",
  "input--with-suffix-divider": "pbui-XRYDs",
  "prefix": "pbui-yQIm8"
};
export var InputFieldWithDropdownHint = function InputFieldWithDropdownHint(_ref) {
  var children = _ref.children,
    hasError = _ref.hasError;
  var hintClasses = clsx(styles.hint, hasError ? styles['hint--has-error'] : styles['hint--no-error']);
  return /*#__PURE__*/_jsx("div", {
    className: hintClasses,
    children: children
  });
};